import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { getUserData } from '../../../services/API'
import { getASRStoryId } from './utils/ASRUtils'
import { selectStudentPreChecks } from '../studentPreChecksSlice'

export default function StudentASRReaderWrapper({history, initialUserInteraction, getReader, config}) {
    
    useEffect(()=>{
        if(!initialUserInteraction){
            history.push('/student')
        }
    }, [])

    const asrModifiedConfig = {
        ...config,
        enableInterventions: false
    }

    if(!initialUserInteraction) return null

    // Get user language preference to determine which ASR story to use
    const userData = getUserData()
    const asrStoryId = getASRStoryId(userData)
    
    // Check for preloaded story
    const { contextStates } = useSelector(selectStudentPreChecks)
    const preloadedStory = contextStates.preloadedASRStory
    const preloadedStoryId = contextStates.preloadedASRStoryId

    const readerManagerProps = {
        asrStoryId: asrStoryId,
        config: asrModifiedConfig,
        // Pass preloaded story if available and matches expected story ID
        preloadedStory: (preloadedStory && preloadedStoryId === asrStoryId) ? preloadedStory : null,
    }

    return (
        <div className='ready-module-asr-check-reader-manager'>
            {getReader(readerManagerProps)}
        </div>
    )
}
